import React from 'react'

export default props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#00112B"
      d="M5.96852 1.83568C6.29197 1.57692 6.34441 1.10495 6.08565 0.781506C5.82689 0.45806 5.35493 0.405619 5.03148 0.664376L2.53148 2.66438C2.20803 2.92313 2.15559 3.3951 2.41435 3.71855C2.67311 4.042 3.14507 4.09444 3.46852 3.83568L5.96852 1.83568Z"
    />
    <path
      fill="#00112B"
      d="M18.9685 0.664376C18.6451 0.405619 18.1731 0.45806 17.9143 0.781506C17.6556 1.10495 17.708 1.57692 18.0315 1.83568L20.5315 3.83568C20.8549 4.09444 21.3269 4.042 21.5857 3.71855C21.8444 3.3951 21.792 2.92313 21.4685 2.66438L18.9685 0.664376Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#00112B"
      d="M12 1.50003C6.06294 1.50003 1.25 6.31296 1.25 12.25C1.25 18.1871 6.06294 23 12 23C17.9371 23 22.75 18.1871 22.75 12.25C22.75 6.31296 17.9371 1.50003 12 1.50003ZM2.75 12.25C2.75 7.14139 6.89137 3.00003 12 3.00003C17.1086 3.00003 21.25 7.14139 21.25 12.25C21.25 17.3587 17.1086 21.5 12 21.5C6.89137 21.5 2.75 17.3587 2.75 12.25Z"
    />
    <path
      stroke="#004360"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.66602 15.3333L15.2657 8.73365"
    />
    <path
      stroke="#004360"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.2657 15.2663L8.66602 8.66669"
    />
  </svg>
)
